export default __webpack_public_path__ + "static/media/chipperKnife.54b496f6.png";